module.exports = __webpack_public_path__ + "static/together-cde9e03fb2a96ed46b4c6afc0c8b7ba1.jpg";